const ConfigMap = {
	"Common Configuration": require('./common.json'),
    "Mongo DB": require('./MongoDB.json'),
    "MySQL DB": require('./MySQLDB.json'),
    "MQTT Broker": require('./MQTT.json'),
	"Notification Management Service": require('./lev-notification-management-api.json'),
    "BACnet Service": require('./Bacnet.json')
}

export default ConfigMap;